import { render, staticRenderFns } from "./BloodTypeEdit.vue?vue&type=template&id=7ec34d0a&scoped=true&"
import script from "./BloodTypeEdit.vue?vue&type=script&lang=js&"
export * from "./BloodTypeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec34d0a",
  null
  
)

export default component.exports